module.exports = __webpack_public_path__ + "img/icon2-1.713151c4.svg";